import React from 'react';
import {Typography} from '@mui/material';

const TabEmpty = ({message}) => (
    <Typography color="text.secondary" py={4} textAlign="center">{message}</Typography>
);

export default TabEmpty;

